import i18n from "homeland/i18n";


// 用户资料页 RSS 图标：点击复制订阅地址 + toast 提示
const TOAST_CLASS = "rss-toast";
let toastTimer = null;

function removeToast() {
  clearTimeout(toastTimer);
  toastTimer = null;
  const el = document.querySelector(`.${TOAST_CLASS}`);
  if (el) el.remove();
}

function showToast(text) {
  let el = document.querySelector(`.${TOAST_CLASS}`);
  if (!el) {
    el = document.createElement("div");
    el.className = TOAST_CLASS;
    document.body.appendChild(el);
  }
  el.textContent = text;
  // 触发过渡动画
  requestAnimationFrame(() => el.classList.add("show"));
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    el.classList.remove("show");
    // 过渡结束后移除节点
    setTimeout(() => {
      if (el && !el.classList.contains("show")) el.remove();
    }, 300);
  }, 3000);
}

// navigator.clipboard 在跨域 iframe 中可能因 Permissions Policy 被拒，
// 需降级到 execCommand 临时文本框方案
async function copyText(text) {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (e) {
      // 落入降级路径
    }
  }

  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.position = "fixed";
  ta.style.top = "-9999px";
  document.body.appendChild(ta);
  ta.select();
  let ok = false;
  try {
    ok = document.execCommand("copy");
  } catch (e) {
    ok = false;
  }
  ta.remove();
  return ok;
}

// 捕获阶段抢断：preventDefault 必须先于 Turbolinks / Backbone 的冒泡
// 监听执行，否则同源 feed URL 会被 Turbolinks 拦成站内 visit
document.addEventListener(
  "click",
  async (e) => {
    // 仅拦截无修饰键的左键点击，其余（中键新开、ctrl/cmd 点击）放行
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)
      return;
    const link = e.target.closest?.("a.rss-feed-link");
    if (!link) return;

    e.preventDefault();
    e.stopPropagation();

    const url = link.href;
    const ok = await copyText(url);
    if (ok) {
      showToast(i18n.t("common.rss_copied"));
    } else {
      showToast(i18n.t("common.rss_copy_failed", { url }));
    }
  },
  true
);

// Turbolinks 页面切换时清掉残留 toast
document.addEventListener("turbolinks:load", removeToast);
